<template>
  <div data-component-group="filter-forms" data-component="label">
    <FiltersForm
      has-phone-sheet
      :applied-filters="appliedFilters"
      :on-clear-filter="clearFilter"
      :has-filters="hasFilters"
      @filter="onFilter"
      @clear="onClearFilters"
      v-model="selectedCountries"
    >
      <template v-slot:phone-actions>
        <slot name="phone-actions" />
      </template>

      <v-text-field
        clearable
        v-model="search"
        type="search"
        label="Search"
        prepend-inner-icon="search"
      />
    </FiltersForm>
  </div>
</template>

<script lang="ts">
  import { defineComponent } from 'vue';
  import FiltersForm from './FiltersBase.vue';
  import { isNonEmptyArr, escapeSearch } from '../../../utils';
  import filterUrlSync from '@/mixins/filterUrlSync';
  import filterChips, { platformChips } from '@/mixins/filterChips';

  // TODO: Translate component

  export default defineComponent({
    mixins: [filterUrlSync, filterChips],
    components: {
      FiltersForm,
    },
    emits: ['clearFilters', 'filter'],
    data() {
      return {
        urlConfig: [
          { field: 'search', urlKey: 'search', type: 'string' },
          { field: 'selectedCountries', urlKey: 'countries', type: 'string[]' },
        ],
        search: null as string | null,
        selectedCountries: [] as string[],
      };
    },
    computed: {
      filterChipFields() {
        const platforms = this.$store.getters['users/countries'] || [];

        return [
          {
            model: 'selectedCountries',
            label: this.$t('platform'),
            toChips: platformChips(platforms),
          },
          { model: 'search', label: 'Search' },
        ];
      },
      hasFilters() {
        const { search, selectedCountries } = this;

        return !!search || isNonEmptyArr(selectedCountries);
      },
    },
    methods: {
      onFilter() {
        const { search, selectedCountries } = this;
        const formattedSearch = escapeSearch(search);

        this.syncFiltersToUrl();
        this.rememberAppliedFilters();

        this.$emit('filter', {
          search: formattedSearch,
          countries: selectedCountries,
        });
      },
      onClearFilters() {
        this.search = null;
        this.selectedCountries = [];

        this.clearFiltersUrl();
        this.forgetAppliedFilters();

        this.$emit('clearFilters');
      },
    },
  });
</script>
